"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _useResponsiveProp = require("./useResponsiveProp");
/**
 * Resolves spacing options from the provided space object.
 *
 * @param {Object} space - The space configuration object.
 * @param {Object} [space.options] - The options for spacing.
 * @param {number|string} [space.options.size] - The size of the spacing. Can be a number or a string.
 * @param {string} [space.options.variant] - The variant of the spacing.
 * @param {number} [space.options.subtract=0] - A value to subtract from the spacing size.
 * @returns {Object} An object containing resolved spacing tokens, variant, overridden flag, and subtract value.
 * @property {Object} tokens - The resolved spacing tokens.
 * @property {number|string} tokens.size - The size of the spacing.
 * @property {string} [variant] - The variant of the spacing.
 * @property {boolean} overridden - Indicates if the size is explicitly overridden as a number.
 * @property {number} subtract - The value to subtract from the spacing size.
 */
const resolveSpacingOptions = space => {
  if (!space?.options) return {};
  const {
    size,
    variant,
    subtract = 0
  } = space.options;
  const overridden = typeof size === 'number';
  return {
    tokens: {
      size
    },
    variant,
    overridden,
    subtract
  };
};

/**
 * Calculates the spacing scale based on the provided space value, viewport, and spacing tokens.
 *
 * @param {Object} spaceValue - The space value configuration, which may include responsive properties.
 * @param {Object} viewport - The current viewport dimensions or configuration.
 * @param {Function} getSpacingTokens - A function that retrieves spacing tokens based on the provided options.
 * @returns {number} The calculated spacing scale, ensuring it is non-negative.
 */
const getSpacingScale = (spaceValue, viewport, getSpacingTokens) => {
  const {
    tokens,
    variant,
    overridden,
    subtract = 0
  } = resolveSpacingOptions(spaceValue);
  const space = !overridden && (spaceValue?.space ?? (0, _useResponsiveProp.resolveResponsiveProp)(spaceValue, viewport, 0));
  const {
    size
  } = getSpacingTokens({
    ...variant,
    space: typeof space === 'number' ? space : 0,
    viewport
  }, tokens);
  return Math.max(size - subtract, 0);
};
var _default = exports.default = getSpacingScale;